import React, { useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Switch,
  Checkbox
} from "@mui/material";
import { Modal, RenderIf } from "@adl/smart-ui-library";

import { v4 } from "uuid";

const initialState = [
  { privacyTypeId: 1, privacyTypeValue: true },
  { privacyTypeId: 2, privacyTypeValue: true },
  { privacyTypeId: 3, privacyTypeValue: true },
  { privacyTypeId: 4, privacyTypeValue: true },
];
const FileMetaModal = ({
  onClose,
  onCancel,
  data,
  index,
  total,
  categories,
  privacyLevels,
}) => {
  const [disableSubmit, setDisableSubmit] = React.useState(false);
  const [fileCategory, setFileCategory] = React.useState(1);
  const [privacyLevel, setPrivacyLevel] = React.useState(initialState);
  const [userSanitised, setUserSanitised] = React.useState(false);
  const [fileName, setFileName] = React.useState(data?.file?.name || '');
  const [filenameError, setFilenameError] = React.useState('');

  const validateFilename = (name) => {
    const regex = /^[a-zA-Z0-9 ._()-]+$/;
    if (!regex.test(name)) {
      setFilenameError('File name cannot have special characters.');
      return false;
    }
    setFilenameError('');
    return true;
  };

  const handleFileName = (event) => {
    const newFilename = event.target.value;
    setFileName(newFilename);
    validateFilename(newFilename);
  };

  const handleFileCategory = (event) => {
    setFileCategory(event.target.value);
  };

  const handleUserSanitised = () => {
    setUserSanitised(!userSanitised);
  };

  const handlePrivacy = (event, value) => {
    setPrivacyLevel((prevPrivacyLevels) =>
      prevPrivacyLevels.map((level) =>
        level.privacyTypeId === value
          ? { ...level, privacyTypeValue: event.target.checked }
          : level
      )
    );
  };
  useEffect(() => {
    validateFilename(data?.file?.name)
    setFileName(data?.file?.name)
    setFileCategory(1);
    setDisableSubmit(false);
    setPrivacyLevel(initialState);
  }, [data]);

  function getStyles() {
    return {
      textAlign: "left",
      borderRadius: "20px",
      padding: "1px 3px",
      fontSize: "14px",
    };
  }
  return (
    <Modal open={true} onClose={onCancel} name="delete-history-confirmation">
      <Modal.Header>Document Settings</Modal.Header>
      <Modal.Content>
        <Typography variant="body1" sx={{ width: "100%", textAlign: "left" }}>
          File {index + 1} of {total}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <TextField
            label="File Name"
            value={fileName}
            onChange={handleFileName}
            error={!!filenameError}
            helperText={filenameError}
          />
          <FormControlLabel control={<Checkbox onChange={handleUserSanitised} />} label="Already sanitised" />

          <FormControl>
            <InputLabel id="fileCategory">File category</InputLabel>
            <Select
              labelId="fileCategory"
              id="fileCategory"
              value={fileCategory}
              onChange={handleFileCategory}
              sx={getStyles()}
            >
              {categories?.map((category) => (
                <MenuItem
                  key={category.documentCategoryId}
                  value={category.documentCategoryId}
                >

                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    {category.name}
                    <RenderIf isTrue={false}>

                      {category.name === "Proposal" ||
                        category.name === "Qual" ? (
                        <Box
                          style={{
                            fontSize: "12px",
                            color: "#999",
                            fontStyle: "italic",
                          }}
                        >
                          Document requires validation
                        </Box>
                      ) : null}
                    </RenderIf>

                  </Box>

                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <RenderIf isTrue={false}>

            <FormGroup>
              {privacyLevels &&
                privacyLevels.map((level) => (
                  <FormControlLabel
                    key={v4()}
                    id={level.privacyTypeId}
                    control={
                      <Switch
                        checked={
                          privacyLevel.find(
                            (item) => item.privacyTypeId === level.privacyTypeId
                          )?.privacyTypeValue || false
                        }
                        onChange={(e) => handlePrivacy(e, level.privacyTypeId)}
                      />
                    }
                    label={`Protect ${level.name}`}
                  />
                ))}
            </FormGroup>
          </RenderIf>

        </Box>
      </Modal.Content>
      <Modal.Footer>
        <Button
          variant="outlined"
          disableElevation
          onClick={onCancel}
          sx={{ width: "100%" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          disabled={disableSubmit || !!filenameError}
          onClick={() => {
            setDisableSubmit(true);
            onClose({
              fileName,
              fileCategory,
              privacyLevel,
              userSanitised
            });
          }}
          sx={{ width: "100%" }}
        >
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileMetaModal;
